import { render, staticRenderFns } from "./BrandFooter.vue?vue&type=template&id=bff9be44&scoped=true"
import script from "./BrandFooter.vue?vue&type=script&lang=js"
export * from "./BrandFooter.vue?vue&type=script&lang=js"
import style0 from "./BrandFooter.vue?vue&type=style&index=0&id=bff9be44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff9be44",
  null
  
)

export default component.exports